
      import QuantityDiscount from './quantity-discount.vue'
      import type { App, Plugin } from 'vue'

      export const QuantityDiscountPlugin: Plugin = {
        install(app: App) {
          app.component('QuantityDiscount', QuantityDiscount)
        },
      }
      export { QuantityDiscount }
      